import type { FC } from "react"
import "./styles.scss"

interface SidebarProps {
  toolUrl: string;
  responsibilities: string[];
  disabledLink?: boolean;
  onToolClick?: () => void;  // Add this new prop
}

export const Sidebar: FC<SidebarProps> = ({ toolUrl, responsibilities, disabledLink, onToolClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onToolClick) {
      e.preventDefault();
      onToolClick();
    }
  };

  return (
    <div className="sidebar p-4">
      <div className="action-button mb-4">
        {!disabledLink ? 
          <a 
            href={toolUrl} 
            className="btn btn-primary btn-view-tool w-100"
            onClick={handleClick}  // Add the click handler
          >
            View Tool
          </a> : 
          <div 
            className="btn btn-secondary btn-view-tool w-100" 
            style={{cursor: 'default', pointerEvents: 'none'}}
          >
          </div>
        }
      </div>

      <div className="responsibilities mb-4">
        <h2 className="responsibilities-title">RESPONSIBILITIES</h2>
        <ul className="responsibilities-list">
          {responsibilities.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <hr className="sidebar-divider" />
    </div>
  )
}
